'use client'

import clsx from 'classnames'
import { usePreloader } from '@/shared/ui/preloader'
import { FirstSection } from '@/sections/first-section'
import { MainEvents } from '@/sections/main-events'
import { AboutMain } from '@/sections/about-main'
import { AboutCards } from '@/sections/about-cards'
import { MainAnalytics } from '@/sections/main-analytics'
import { Partners } from '@/sections/partners'
import { CardsAnimation } from '@/shared/ui/cards-animation/cards-animation'
import style from './main-page.module.scss'

export function MainPage(props: any) {
  const { mainPageSettings, comments, events, goals, posts, partners, eventCategories, postCategories, pinnedEvent } =
    props
  const { loaded } = usePreloader()

  return (
    <div>
      <FirstSection comments={comments} mainPageSettings={mainPageSettings} className={style.first} loaded={loaded} />
      <main>
        <MainEvents
          className={clsx(style.second, 'change-color-js', 'white-section-js')}
          events={events?.items}
          loaded={loaded}
          eventCategories={eventCategories}
          pinnedEvent={pinnedEvent}
        />

        <AboutMain goals={goals} mainPageSettings={mainPageSettings} loaded={loaded} />

        <CardsAnimation>
          <AboutCards loaded={loaded} />
        </CardsAnimation>

        <MainAnalytics posts={posts?.items} postCategories={postCategories}>
          <Partners partners={partners} />
        </MainAnalytics>
      </main>
    </div>
  )
}
